import {
    computeBrushParametrics,
    computeBrushRadiusAtMousePosition,
    createParametrics,
    initStateFromFeatures,
    initStateFromStartingFeatures,
} from "../utils/oneWayUtils"

export let StabiloMode = {}

const cursorFilePathes = {
    primary: "assets/resources/circle_cursor.png",
    green: "assets/resources/circle_cursor_vert-bon.png",
    yellow: "assets/resources/circle_cursor_jaune_remplacement-type.png",
    orange: "assets/resources/circle_cursor_orange_moyen.png",
    red: "assets/resources/circle_cursor_rouge-mauvais.png",
    blue: "assets/resources/circle_cursor_bleu_présence.png",
    purple: "assets/resources/circle_cursor_violet_autre-type.png",
}

// When the mode starts this function will be called.
// The value returned should be an object and will be passed to all other lifecycle functions
StabiloMode.onSetup = function (opts) {
    var state = {}

    state.options = opts

    state.roadSegments = opts.roadSegments
    state.startingFeatures = opts.startingFeatures

    this.map["dragPan"].disable()
    if (opts.color?.name) {
        this.map.getCanvas().style.cursor = `url(${cursorFilePathes[opts.color.name.toLowerCase()]}) 32 32, pointer`
    } else {
        this.map.getCanvas().style.cursor = `url(${cursorFilePathes.primary}) 32 32, pointer`
    }

    const currentFeatures = opts.drawFeatures || []

    if (currentFeatures.length || opts.hasBeenUpdated) {
        state.parametricSegments = []
        state.featureIds = []

        initStateFromFeatures(state, currentFeatures)
    } else {
        const defaultParametrics = initStateFromStartingFeatures(state)
        createParametrics(this, state, defaultParametrics)
    }

    return state
}

StabiloMode.onDrag = function (state, e) {
    if (this.map && state.roadSegments) {
        const brushRadius = computeBrushRadiusAtMousePosition(this, e)

        const paintedParametrics = computeBrushParametrics(state, brushRadius, e)

        if (paintedParametrics.length) {
            const featuresUpdated = createParametrics(this, state, paintedParametrics)

            if (featuresUpdated) {
                this.map.fire("draw.paint_updated")
            }
        }
    }
}

StabiloMode.onMouseDown = function (state, e) {
    this.onDrag(state, e)
}

StabiloMode.toDisplayFeatures = function (state, geojson, display) {
    display(geojson)
}

StabiloMode.onTrash = function (state) {
    const defaultParametrics = initStateFromStartingFeatures(state)
    createParametrics(this, state, defaultParametrics)
}